import React, { Component } from "react";

import { Row, Col } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import Responsive from "react-responsive";

import Navbar from "../../MainComponents/CommonCom/Navbar.js";
import FestivalMain from "../../MainComponents/ContactUsCom/FestivalCom/FestivalMain.js";
import Footer from "../../MainComponents/CommonCom/Footer.js";

import { MobileHPMenu } from "../../Statics/HomePage/MobileHPMenu.js";

// Responsive Part
const LaptopDesktop = (props) => <Responsive {...props} minWidth={1025} />;
const Tablet = (props) => (
  <Responsive {...props} minWidth={426} maxWidth={1024} />
);
const Mobile = (props) => <Responsive {...props} maxWidth={425} />;

class Festival extends Component {
  componentDidMount = () => {
    MobileHPMenu()
  }
  render() {
    return (
      <div>
        <Mobile>
          <Navbar history={this.props.history}  />
          <FestivalMain />
          <Footer  history={this.props.history}/>
        </Mobile>
        <Tablet>
          <Navbar size="tablet"  history={this.props.history} />
          <FestivalMain size="tablet" />
          <Footer size="tablet"  history={this.props.history}/>
        </Tablet>
        <LaptopDesktop>
          <div>
            <Navbar size="laptopdesktop" history={this.props.history}  />
            <FestivalMain size="laptopdesktop" />
            <Footer size="laptopdesktop"  history={this.props.history}/>
          </div>
        </LaptopDesktop>
      </div>
    );
  }
}
export default Festival;
